/** Default role-list filter: system roles stay hidden. */
export const DEFAULT_ROLE_COLUMN_FILTERS = Object.freeze({
    isSystemRole: Object.freeze(['false']),
});

function selectedSystemRoleValues(values) {
    return Array.isArray(values) ? values.map((value) => String(value)) : [];
}

/**
 * Exclusive list choice. Checking "show" replaces "hide", and clearing
 * returns to the hidden default.
 * @param {string[]|undefined} previous
 * @param {string[]|undefined} nextValues
 * @returns {string[]}
 */
export function applySystemRoleFilterChange(previous, nextValues) {
    const prev = new Set(selectedSystemRoleValues(previous));
    const next = selectedSystemRoleValues(nextValues);
    const added = next.filter((value) => !prev.has(value));

    if (added.includes('true')) return ['true'];
    if (added.includes('false')) return ['false'];
    if (next.includes('false')) return ['false'];
    if (next.includes('true')) return ['true'];
    return ['false'];
}

/**
 * UI filter state → API `filter_isSystemRole` values.
 * "Show" includes custom roles as well as system roles.
 * @param {Record<string, string[]>} [columnFilters]
 */
export function resolveRoleListFilters(columnFilters = {}) {
    const selected = applySystemRoleFilterChange(
        undefined,
        columnFilters?.isSystemRole,
    );
    return {
        ...(columnFilters || {}),
        isSystemRole: selected.includes('true') ? ['true', 'false'] : ['false'],
    };
}

/**
 * Keeps the system-role choice exclusive inside the table filter map.
 * @param {Record<string, string[]>} [columnFilters]
 * @param {string[]|undefined} previousSystemRole
 */
export function normalizeRoleColumnFilters(columnFilters = {}, previousSystemRole) {
    return {
        ...(columnFilters || {}),
        isSystemRole: applySystemRoleFilterChange(previousSystemRole, columnFilters?.isSystemRole),
    };
}
